import { makeStyles } from "@material-ui/core";
import AppColors from './../colors/AppColors';

export const useAppIconStyle = makeStyles((theme) => ({
    appIcon: {
        color: AppColors.WHITE,
        marginLeft: 60,
        width: 50,
        height: 35,
        alignSelf: 'center',
        [theme.breakpoints.down('md')]: {
            marginLeft: 20,
        },
    },
    appName: {
        color: AppColors.WHITE,
        marginLeft: 10,
        fontSize: 28,
        fontWeight: 600,
        cursor: 'pointer',
    },
}));